interface SeoHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
}

const DEFAULT_TITLE = "Music Brackets - Rank Your Favorite Songs";
const DEFAULT_DESCRIPTION =
  "Create song brackets, vote on matchups, and discover your top tracks. Play artist brackets, custom games, and share your results.";
const SITE_URL = "https://musicbrackets.com";

export default function SeoHead({
  title,
  description,
  canonical,
  ogImage,
}: SeoHeadProps) {
  const fullTitle = title ? `${title} | Music Brackets` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
  const image = ogImage || `${SITE_URL}/og-image.png`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Music Brackets" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </>
  );
}
